import router from './router'

const zhCN = { router: router.zhCN }
const enUS = { router: router.enUS }
export default { zhCN, enUS }